// extracted by mini-css-extract-plugin
export var icon = "gGE-E";